import { FC, useEffect, useState } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import { PiPencilBold } from "react-icons/pi";
import SimpleDocPreviewer from "../common/docs/simple-doc-previewer";
import SimpleCard from "../common/simple-card";
import SimpleModal from "../common/simple-modal";
import useFormBinder from "lib/hooks/useFormBinder";
import SimpleTextbox from "../common/simple-textbox";
import SimpleButton from "../common/simple-button";
import SimpleDocUploader from "../common/docs/simple-doc-uploader";

interface ProfilePicCardProps {
  isLoading?: boolean;
  isEditable?: boolean;
  userProfile?: UserProfile;
  profilePicUrl?: string;

  onProfileUpdate?: (values: UserProfile) => void;
  onProfilePicUpdate?: (values: File) => void;
}

const ProfilePicCard: FC<ProfilePicCardProps> = ({
  isLoading,
  isEditable,
  userProfile,
  profilePicUrl,
  onProfileUpdate,
  onProfilePicUpdate,
}) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const { handleChange, values, resetValues } =
    useFormBinder<UserProfile>(userProfile);

  const [userProfilePic, setUserProfilePic] = useState<File | null>(null);
  const [userProfilePicUrl, setUserProfilePicUrl] = useState<string | null>(
    profilePicUrl
  );

  useEffect(() => {
    if (userProfile) {
      resetValues(userProfile);
    }
  }, [userProfile]);

  useEffect(() => {
    if (profilePicUrl) {
      setUserProfilePicUrl(profilePicUrl);
    }
  }, [profilePicUrl]);

  return (
    <>
      <SimpleCard className="profile-banner">
        <Row className="pe-2">
          <Col sm="3" className="align-self-center">
            {isEditable ? (
              <SimpleDocUploader
                docUrl={userProfilePicUrl}
                doc={userProfilePic}
                onChange={(files) => {
                  setUserProfilePic(files[0]);
                  onProfilePicUpdate?.(files[0]);
                }}
                onDelete={() => {
                  setUserProfilePic(null);
                  setUserProfilePicUrl(null);
                }}
              />
            ) : (
              <SimpleDocPreviewer
                isShowRemoveButton={isEditable}
                docUrl={userProfilePicUrl}
              />
            )}
          </Col>
          <Col
            sm={isEditable ? 7 : 9}
            className="align-self-end blur-bg rounded"
          >
            <h1 className="">
              {userProfile?.firstName}&nbsp;{userProfile?.lastName}
            </h1>
            <hr />
            <small className="text-wrap fw-bold">
              Email: {userProfile?.email}&nbsp; Contact Number:{" "}
              {userProfile?.contactNumber}
            </small>
          </Col>
          {isEditable && (
            <Col sm="2" className="text-end">
              <SimpleButton
                onClick={() => setIsShowModal(true)}
                suffixIcon={<PiPencilBold />}
                isLoading={isLoading}
              >
                Edit
              </SimpleButton>
            </Col>
          )}
        </Row>
      </SimpleCard>

      <SimpleModal
        size="sm"
        title="Edit Details"
        open={isShowModal}
        close={() => setIsShowModal(false)}
        footer={
          <Button
            onClick={() => {
              console.log(values);

              onProfileUpdate?.(values);
              setIsShowModal(false);
            }}
          >
            Update
          </Button>
        }
      >
        <Form>
          <SimpleTextbox
            label="First name"
            id="firstName"
            value={values?.firstName}
            onChange={handleChange}
          />
          <SimpleTextbox
            label="Last name"
            name="lastName"
            value={values?.lastName}
            onChange={handleChange}
          />
          <SimpleTextbox
            label="Email"
            id="email"
            value={values?.email}
            onChange={handleChange}
          />
          <SimpleTextbox
            label="Contact number"
            id="contactNumber"
            value={values?.contactNumber}
            onChange={handleChange}
          />
        </Form>
      </SimpleModal>
    </>
  );
};

export default ProfilePicCard;
